import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StadiumCamerasService } from 'app/services/stadium-cameras.service';
import { Stadium } from 'app/models/stadium';
import { CompetitionService } from 'app/services/competition.service';
import { Competition } from 'app/models/competition';
import { GoogleTagManagerService } from 'app/services/google-tag-manager.service';
import { DialogHelperService } from 'app/services/dialog-helper.service';
import { BehaviorSubject, Subscription } from 'rxjs';

@Component({
  selector: 'app-stadium',
  templateUrl: './stadium.component.html',
  styleUrls: ['./stadium.component.scss']
})
export class StadiumComponent implements OnInit {
  public stadiumData;
  stadium: Stadium;
  public fullScreenMode: boolean = false;
  private competition: Competition;
  private fullscreenObserver = new BehaviorSubject<boolean>(false);
  private subscription: Subscription;
  private competitionSubscription: Subscription;

  constructor(
    private stadiumCamerasService: StadiumCamerasService,
    private competitionService: CompetitionService,
    private gtmService: GoogleTagManagerService,
    private router: Router
  ) {}

  ngOnInit() {
    this.competition = this.competitionService.getCompetitionSelected();

    // If competition is not loaded yet (page refresh), wait for it
    if (!this.competition) {
      this.competitionSubscription = this.competitionService.getCompetitionSelectedSubscriber()
        .subscribe((assetBackground) => {
          if (assetBackground) {
            this.competition = this.competitionService.getCompetitionSelected();
            this.initializeStadium();
          }
        });
    } else {
      this.initializeStadium();
    }

    this.subscription = this.fullscreenObserver
      .subscribe((value) => {
        this.fullScreenMode = value
      });
  }

  private initializeStadium() {
    if (!this.competition) return;

    const urlParts = this.router.url.split('/').filter(s => s);
    this.gtmService.pushVirtualPageView('stadium', this.competition.id, { parentParams: { id: urlParts[0] || null } });
    this.stadiumData = {
      id: this.competition.id,
      name: 'Stadium',
      source: 'STADIUM'
    };
    if (this.competition.hasOwnProperty('hide_stadium') && this.competition.hide_stadium === true) {
      this.router.navigate(['/competition']);
      return;
    }
    this.stadiumCamerasService
      .getAll()
      .subscribe(res => (this.stadium = res));
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    if (this.competitionSubscription) {
      this.competitionSubscription.unsubscribe();
    }
  }
}
